// urls
export const APIBaseUrl =
  process.env.NODE_ENV === "production"
    ? import.meta.env.VITE_API_PRO_BASE_URL
    : import.meta.env.VITE_API_DEV_BASE_URL;
export const APIBaseAdminUrl =
  process.env.NODE_ENV === "production"
    ? import.meta.env.VITE_API_PRO_BASE_ADMIN_URL
    : import.meta.env.VITE_API_DEV_BASE_ADMIN_URL;
export const socketBaseUrl = import.meta.env.VITE_API_BASE_SOCKET_URL;

// secret keys
export const DATA_KEY = "bqwOlSSbg9VLtQuMp3mB7OAWQQwrvj6V";
